// extracted by mini-css-extract-plugin
export var fullGrid = "_1y-3";
export var pdpPreviewContainer = "_1y-1";
export var previewContainer = "_1y-0";
export var togglePreviewContainer = "_1y-2";